import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import AiGuidePage from "../ai-guide/ui/AiGuidePage";

/** Adaptor discovery — under Data Pipeline; previously an AI Context tab. */
const AdaptorDiscovery = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <AiGuidePage section="adaptor" />
    </PageContentShell>
  </DashboardLayout>
);

export default AdaptorDiscovery;
